import { UpdateDisplayGroupRole, UpdateDisplayGroupRoleVariables } from './__generated__/UpdateDisplayGroupRole'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

export const UPDATE_DISPLAY_GROUP_ROLE_MUTATION = gql`
  mutation UpdateDisplayGroupRole($input: UpdateDisplayGroupRoleInputV2!) {
    updateDisplayGroupRoleV2(input: $input) {
      ... on DisplayGroupRoleErrorV2 {
        type
        error
      }
      ... on DisplayGroupRoleV2 {
        id
        role
        person {
          id
          emailAddress
          firstName
          lastName
        }
      }
    }
  }
`

export const useUpdateDisplayGroupRole = () => {
  return useMutation<UpdateDisplayGroupRole, UpdateDisplayGroupRoleVariables>(UPDATE_DISPLAY_GROUP_ROLE_MUTATION)
}
